import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Core2Config } from "../shared/core2Config";
import { WMSPickingListLineContainer } from "../../../../../models/aggregates/warehouse/index";
import { ApiVisa } from '../shared';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../shared/api-response.model';

@Injectable({ providedIn: "root" })
export class WMSPickingListLineService extends BaseApiTemplateService<WMSPickingListLineContainer> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "wms-picking-list-lines/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "wms-picking-list-lines/backoffice-ep";
    this.httpClient = http;
  }

     public addAllPickingLinesToCart(payload: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        let url;
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "wms-picking-list-lines/add-all-lines-to-picking-cart/backoffice-ep";
        }
        return this.httpClient.post<ApiResponseModel<any>>(
          url,
          payload,
          this.getHttpHeader(visa)
        );
    }

    
     public addSelectedPickingLinesToCart(payload: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        let url;
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "wms-picking-list-lines/add-selected-lines-to-picking-cart/backoffice-ep";
        }
        return this.httpClient.post<ApiResponseModel<any>>(
          url,
          payload,
          this.getHttpHeader(visa)
        );
    }


}
